import { useEffect } from 'react';

import { toast } from 'sonner';
import { useChains, useSwitchChain } from 'wagmi';

import { useConnectEvmWallet, useWatchFirstTokenSelectionChainIdEvents } from '@/networks/evm';
import { useSwapContext } from '@/pages/Swap/context';

import useSwitchEvmChainByCurrency from './useSwitchEvmChainByCurrency';

export function useSwitchEvmChainOnTokenChange() {
  const chains = useChains();
  const { tokenFrom } = useSwapContext();
  const { isConnected } = useConnectEvmWallet();
  const { switchChainAsync } = useSwitchChain();
  const { switchChainByCurrency } = useSwitchEvmChainByCurrency();

  useWatchFirstTokenSelectionChainIdEvents((newChainId, prevChainId) => {
    if (isConnected && newChainId && newChainId !== prevChainId) {
      void switchChainAsync({ chainId: newChainId }).then(() => {
        const { name } = chains.find((c) => c.id === newChainId) || {};
        void toast.success(`Switched active EVM chain to ${name}`);
      });
    }
  });

  useEffect(() => {
    if (isConnected && chains.length > 0) {
      // On load check which EVM chain is connected
      setTimeout(() => {
        void switchChainByCurrency(tokenFrom);
      }, 1000);
    }
  }, [isConnected]);
}
